import React from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';

const PdfProcessingModal = ({ isOpen }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered fade backdrop="static">
      <ModalBody>
        <div className="d-flex flex-column justify-content-center align-items-center py-5">
          <Spinner className="mb-3 text-primary" />

          <div className="fs-4 fw-semibold text-primary mb-2">Processing PDF</div>

          <div className="fs-6 text-center text-muted px-3">
            This may take some time. Please do not refresh or close this page.
            <br />
            <span className="fw-semibold text-danger">
              Refreshing the page may interrupt the process and cause data loss.
            </span>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

PdfProcessingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired
};

export default PdfProcessingModal;
